import { lang } from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import { MOBILE_SIZE } from "src/resources/constant";

const useResize = () => {
  const location = useLocation();
  const [width, setWidth] = useState<number>(window.innerWidth);
  const language = useSelector((state: any) => state.lookup.language);

  function handleWindowSizeChange() {
    const scale = window.devicePixelRatio;
    const elements = [
      document.querySelector(".grid-inner-wrapper") as HTMLElement,
      document.querySelector(".invoice-details-footer") as HTMLElement,
      document.querySelector(".invoice-header") as HTMLElement,
    ];

    elements.forEach((element) => {
      if (element) {
        element.style.transform = `scale(${scale >= 1.5 ? 0.9 : 1})`;
        element.style.transformOrigin = "0 0";
        if (scale >= 1.5) {
          if (language === "ar") {
            element.style.marginRight = "-10%";
            element.style.marginLeft = "6%";
          } else {
            element.style.marginRight = "6%";
            element.style.marginLeft = "0";
          }
        }
      }
    });

    setWidth(window.innerWidth);
  }
  useEffect(() => {
    handleWindowSizeChange();
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, [location.pathname, language]);
  return { isMobile: width <= MOBILE_SIZE };
};

export default useResize;
